const OFFERS_QUERIES = {
  OFFERS_LIST: 'offers-list',
}

export {OFFERS_QUERIES}
